import { render, staticRenderFns } from "./PatientIdentifierListInput.vue?vue&type=template&id=113ceb06&scoped=true&"
import script from "./PatientIdentifierListInput.vue?vue&type=script&lang=js&"
export * from "./PatientIdentifierListInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientIdentifierListInput.vue?vue&type=style&index=0&id=113ceb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ceb06",
  null
  
)

export default component.exports